var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('header-site'),_c('main',{staticStyle:{"flex":"1 0 auto"}},[_c('router-view')],1),_c('footer-site')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }